import React from 'react';
import { RootStore, StoreContext } from '../stores/RootStore';

export const StoreProvider = ({ children }) => {
    const rootStore = React.useMemo(() => new RootStore(), []);

    // Wait for settings to load before rendering children
    const [settingsLoaded, setSettingsLoaded] = React.useState(false);
    
    React.useEffect(() => {
        const checkSettingsLoaded = () => {
            if (rootStore.settingsStore.isLoaded) {
                setSettingsLoaded(true);
            } else {
                setTimeout(checkSettingsLoaded, 50);
            }
        };
        
        checkSettingsLoaded();
    }, [rootStore.settingsStore]);

    return (
        <StoreContext.Provider value={rootStore}>
            {settingsLoaded ? children : <div>Loading settings...</div>}
        </StoreContext.Provider>
    );
};